export const getCodeBlockId = (fileName: string, id: number): string => {
  return `${fileName.replace(/[^a-zA-Z0-9 ]/g, '')}-${id}`;
};
